module.exports = __webpack_public_path__ + "img/BeccaF1.e36a9659.jpg";